import { memo, useState } from "react";
import { Grid2, Typography, Link, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Image } from "mui-image";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useSnackbar } from "../utils/index.js";
import Spinner from "../components/Spinner.js";
import useAuthenticationStyles from "../components/styles/Authentication.js";
import { forgotPassword } from "../api/index.js";
import Form from "../components/Form.js";
import logo from "../assets/images/logo-white-first.png";

const ForgotPassword = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const classes = useAuthenticationStyles();
	const { success, error } = useSnackbar();
	const navigate = useNavigate();

	const submitHandler = async (values) => {
		setIsSubmitting(true);

		try {
			const { success: successCode, message } = await forgotPassword(values.username);

			if (successCode) {
				success(message);
				navigate("/");
			} else {
				error(message);
			}
		} catch (error_) {
			console.log(error_);
		}

		setIsSubmitting(false);
	};

	const formContent = [
		{
			customType: "input",
			id: "username",
			type: "text",
			placeholder: "Όνομα χρήστη",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton disabled>
							<AccountCircle />
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "button",
			id: "submit",
			type: "submit",
			text: "Επαναφορά Κωδικού",
		},
	];

	return (
		<>
			<Spinner open={isSubmitting} />
			<Grid2 container direction="row" justifyContent="center" align="center" className={classes.root}>
				<Grid2
					item
					container
					direction="column"
					justifyContent="center"
					alignItems="center"
					sm={5}
					xs={12}
					mt={'-10rem'}
					sx={{ "> .MuiGrid-item": { p: 1 } }}
				>
					<Grid2 item mb={3}>
						<Image src={logo} alt="Logo" className={classes.logo} />
					</Grid2>
					<Grid2 item mt={2}>
						<Typography
							variant="h7"
							fontWeight="bold"
							className={classes.subtitle}
						>
							{"Παρακαλώ εισάγετε το όνομα χρήστη σας και θα σας σταλεί e-mail για την αλλαγή κωδικού."}</Typography>
					</Grid2>
					<Grid2
						item
						container
						direction="column"
						justifyContent="center"
						alignItems="center"
						sx={{ width: "100%" }}
					>
						<Form content={formContent} validationSchema="forgotPasswordSchema" onSubmit={submitHandler}
							sx={{ width: "600px" }} />
					</Grid2>
					<Grid2
						item
						container
						direction="column"
						justifyContent="center"
						alignItems="space-between"
					>
						<Grid2 item>
							<Typography variant="h7" color="white.main">{"Αλλίως, "}</Typography>
							<Typography variant="h7" className={classes.subtitle}>
								<Link color="inherit" underline="none" href="/">{"Συνδεθείτε"}</Link>
							</Typography>
						</Grid2>
					</Grid2>
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(ForgotPassword);
